exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview{width:64px;height:64px;border-radius:4px}.preview>img{width:inherit;height:inherit;-o-object-fit:cover;object-fit:cover;border:2px solid #888}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-367998f4","scoped":false,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/forms/FormFile.vue
// module id = 1ZBg
// module chunks = 0 2